const Movie = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m4.549 4.964 1.805 1.804a1 1 0 0 0 1.414-1.414L6.914 4.5H9.11q.052.078.121.147l2.122 2.121a1 1 0 0 0 1.414-1.414l-.854-.854h2.197q.052.078.121.147l2.122 2.121a1 1 0 0 0 1.414-1.414l-.855-.854H18A2.5 2.5 0 0 1 20.5 7v10a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 17V7c0-.84.414-1.583 1.049-2.036M4.5 17V8h15v9a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 17"
      clipRule="evenodd"
    />
  </>
)
export default Movie
